import _ from 'underscore';
import { odata } from '@bingads-webui/http-util';


const odataURLMap = {
  Account: '/Customers(:customer_id)/Accounts(:account_id)/AdCustomizerAttributes/Default.GetEditorialReasons',
  Campaign: '/Customers(:customer_id)/Accounts(:account_id)/Campaigns(:campaign_id)/AdCustomizerAttributes/Default.GetEditorialReasons',
  AdGroup: '/Customers(:customer_id)/Accounts(:account_id)/Campaigns(:campaign_id)/AdGroups(:adgroup_id)/AdCustomizerAttributes/Default.GetEditorialReasons',
  Keyword: '/Customers(:customer_id)/Accounts(:account_id)/Campaigns(:campaign_id)/AdGroups(:adgroup_id)/Keywords(:keyword_id)/AdCustomizerAttributes/Default.GetEditorialReasons',
};
export function getAppealRejections({
  attributeId,
  ajaxOptions,
  valueLevel,
}) {
  const odataURL = odataURLMap[valueLevel];
  const options = _.extend(
    { url: odataURL, contentType: 'application/json' }, ajaxOptions,
    {
      data: {
        EntityIds: [parseInt(attributeId, 10)],
      },
    }
  );

  return odata.post(options)
    .then((data) => {
      if (data && !data.Errors) {
        return data;
      }
      return {};
    });
}
